const getDisplayRowIndex = require("./getDisplayRowIndex")
const getImportDataRows = require("./getImportDataRows");

function getRowsToGeocode(vm, $translate) {
  return getRowsGeocodeHelper(true, vm, $translate);
}

function getRowsNotToGeocode(vm, $translate) {
  return getRowsGeocodeHelper(false, vm, $translate);
}

function getRowsGeocodeHelper(toGeocode, vm, $translate) {
  const importRowsToSubmit = getImportDataRows(vm);
  const rows = importRowsToSubmit
    .map((row, i) => {
      if (shouldGeocodeRow(row, vm) === toGeocode) {
        return getRowObjFromArray(row, i, vm);
      }
    }).filter(a => a);
  if (vm.isPlacesImport) {
    return nameUnnamedRows(rows, $translate);
  } else {
    return rows;
  }
}

//Given a row in array format (i.e. ["1", "2", "08540"]) get an object version of it (i.e. { Latitude: "1", Longitude: "2", "Zip": "08540"})
//The keys are the field names (internal ones, in the importField.js object's name property). The values are the row's CSV input contents
function getRowObjFromArray(row, i, vm) {
  const retObj = {};
  for (let j = 0; j < row.length; j++) {
    if (vm.headers[j] === "Skip") {
      continue;
    }
    if (vm.headers[j] === "LatLon") {
      const [lat, lon] = row[j].split(",");
      retObj.Latitude = lat;
      retObj.Longitude = lon;
    } else {
      retObj[vm.headers[j]] = row[j];
    }
  }
  retObj.RowNum = getDisplayRowIndex(i, vm);
  return retObj;
}

//Given row and field name get row/col string entry that has that field
// returns non-empty string (good), "" (omitted), or undefined (missing from cols)
function getRowVal(row, fieldKey, vm) {
  const index = vm.headers.indexOf(fieldKey);
  return row[index];
}

function nameUnnamedRows(rows, $translate) {
  var unnamedCounter = 1;
  for (var row of rows) {
    if (!row.PlaceName) {
      row.PlaceName = $translate.instant("templates.importPlaces.defaultImportedPlaceName", {
        num: unnamedCounter
      });
      unnamedCounter++;
    }
  }
  return rows;
}

//Should we geocode vm row? (Row must have valid address combo)
function shouldGeocodeRow(row, vm) {
  const hasCity = Boolean(getRowVal(row, "City", vm));
  const hasState = Boolean(getRowVal(row, "State", vm));
  const hasZip = Boolean(getRowVal(row, "Zip", vm));
  const hasLat = Boolean(getRowVal(row,"Latitude", vm));
  const hasLon = Boolean(getRowVal(row,"Longitude", vm));
  const hasLatLon = Boolean(getRowVal(row,"LatLon", vm));
       
  return  (hasLat && hasLon) || hasLatLon || hasZip || (hasCity && hasState);

}

module.exports = { getRowsToGeocode, getRowsNotToGeocode };





// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-import/vm-helpers/getRowsGeocodeHelper.js